import ActionTypes from "../constants/deck";

const initialState = {
    materialDeckData : {},
    isLoading: false,
    loaderMessage: "",
    leadDeckImageUrls: {},
    roomScreenShots: {},
    materialDeckUrl: {},
}
export default function reducer(state = initialState, action: any = {}) {
    switch(action.type){
        case ActionTypes.FETCH_MATERIAL_DECK_DATA:
            return {
                ...state,
                materialDeckData: action.result
            }
        case ActionTypes.FETCH_MATERIAL_DECK_DATA_SUCCESS:
            return {                
                ...state,
                materialDeckData: action.result
            }
        case ActionTypes.FETCH_MATERIAL_DECK_DATA_FAIL:
            return{
                ...state,
                materialDeckData: {}
            }
        case ActionTypes.SET_LOADER:
            return{
                ...state,
                isLoading: action.result.isLoading,
                loaderMessage: action.result.msg
            }
        case ActionTypes.LEAD_DECK_IMAGES_CHECK_SUCCESS:
            return{
                ...state,
                leadDeckImageUrls: action.result
            }
        case ActionTypes.GET_SCREENSHOTS:
        case ActionTypes.GET_SCREENSHOTS_FAIL:
            return {
                ...state,
                roomScreenShots: {}
            }
        case ActionTypes.GET_SCREENSHOTS_SUCCESS:
            return {
                ...state,
                roomScreenShots: action.result
            }  
        case ActionTypes.UPDATE_MATERIAL_DECK_URL_SUCCESS: {
            const { pptId } = action.result || {};
            if(!pptId){
                return state;
            }
            return {
                ...state,
                materialDeckData: {
                    ...(state.materialDeckData as any),
                    materialDeckUrl: JSON.stringify(pptId)
                }
            }
        }
        case ActionTypes.UPDATE_MATERIAL_DECK_URL_FAIL: {
            return state;
        }
    }
    return state
}